import {
  TextProperty,
  FormPageInputItem,
  FormPageInputItemText,
  TextPropertyZipCode,
  TextPropertyZipCodeWithoutHyphen,
  TEXT_PROPERTY_INPUT_TYPE,
  StringConvertRule,
} from 'shared';
import { convertString } from '../../../converter';
import { FormFieldInputProps, FormFieldInputItemProps } from '../shared';

export type TextInputProps = FormFieldInputProps<
  TextProperty,
  FormPageInputItemText
>;

type AdditionalZipCodeProps = {
  onAutoCompleteAddressButtonClick: (zipCode?: string) => Promise<void>;
};

export type FormFieldZipCodeInputProps<
  P extends TextProperty = TextProperty,
  I extends FormPageInputItem = FormPageInputItemText,
> = FormFieldInputProps<P, I> & AdditionalZipCodeProps;

export type FormFieldZipCodeInputItemProps<
  P extends TextProperty = TextProperty,
  I extends FormPageInputItem = FormPageInputItemText,
> = FormFieldInputItemProps<P, I> & AdditionalZipCodeProps;

type ZipCodeInputFormat = (
  | TextPropertyZipCode
  | TextPropertyZipCodeWithoutHyphen
)['inputFormat'];
export const isZipCodeInputFormat = (
  inputFormat: TextProperty['inputFormat'],
): inputFormat is ZipCodeInputFormat =>
  inputFormat.inputType === TEXT_PROPERTY_INPUT_TYPE.zipCode ||
  inputFormat.inputType === TEXT_PROPERTY_INPUT_TYPE.zipCodeWithoutHyphen;

export const convertInputTextValue = (
  stringConvertRule: StringConvertRule | undefined,
  updateValue: string | undefined = '',
): string => {
  if (stringConvertRule == null) {
    return updateValue;
  }
  const convertValue = convertString(stringConvertRule);
  const convertedValue = convertValue(updateValue);
  return convertedValue;
};
